import axios from "axios";
import Cookies from "universal-cookie";
import { config } from "../../../config/config";
const cookies = new Cookies();

class ApiQuery {
  getToken() {
    return cookies.get("token");
  }

  async get(url) {
    try {
      const token = this.getToken();
      const configuration = {
        method: "get",
        url: `${config.SERVER}${url}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      };
      let result = await axios(configuration);
      return result.data;
    } catch (error) {
      console.log("apiQuery.get error:", error);
      return null;
    }
  }

  async post(url, data) {
    try {
      const token = this.getToken();
      const configuration = {
        method: "post",
        url: `${config.SERVER}${url}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
        data: data,
      };
      let result = await axios(configuration);
      return result.data;
    } catch (error) {
      console.log("apiQuery.post error:", error);
      return null;
    }
  }

  async postSimple(url, data) {
    try {
      const token = this.getToken();
      const configuration = {
        method: "post",
        url: `${config.SERVER}${url}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
        data: data,
      };
      let result = await axios(configuration);
      return result.data;
    } catch (error) {
      console.log("apiQuery.postSimple error:", error);
      return null;
    }
  }

  async deleteSimple(url, data) {
    try {
      const token = this.getToken();
      const configuration = {
        method: "delete",
        url: `${config.SERVER}${url}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
        data: data,
      };
      let result = await axios(configuration);
      return result.data;
    } catch (error) {
      console.log("apiQuery.deleteSimple error:", error);
      return null;
    }
  }

  async postFormData(url, data) {
    try {
      const token = this.getToken();
      const configuration = {
        method: "post",
        url: `${config.SERVER}${url}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
        data: data,
      };
      let result = await axios(configuration);
      return result.data;
    } catch (error) {
      console.log("apiQuery.postFormData error:", error);
      return null;
    }
  }

  async putFormData(url, data) {
    try {
      const token = this.getToken();
      const configuration = {
        method: "put",
        url: `${config.SERVER}${url}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
        data: data,
      };
      let result = await axios(configuration);
      return result.data;
    } catch (error) {
      console.log("apiQuery.putFormData error:", error);
      return null;
    }
  }

  async put(url, data) {
    try {
      const token = this.getToken();
      const configuration = {
        method: "put",
        url: `${config.SERVER}${url}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
        data: data,
      };
      let result = await axios(configuration);
      return result.data;
    } catch (error) {
      console.log("apiQuery.put error:", error);
      return null;
    }
  }

  async delete(url) {
    try {
      const token = this.getToken();
      const configuration = {
        method: "delete",
        url: `${config.SERVER}${url}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      };
      let result = await axios(configuration);
      return result.data;
    } catch (error) {
      console.log("apiQuery.delete error:", error);
      return null;
    }
  }
}

export default ApiQuery;
